export default "__VITE_ASSET__Cz4FyXp7__"